import React from "react";

function ArrowRight({ width = 24, height = 25, fill = "#fff" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2472_28534)">
        <path
          d="M4.90039 3.43366L11.4671 10.0003L4.90039 16.567L6.66706 18.3337L15.0004 10.0003L6.66706 1.66699L4.90039 3.43366Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default ArrowRight;
